import React from 'react'
import time from "../assets/time (2).png"
import upload from "../assets/upload.png"
import user from "../assets/user.png"
import { HeaderData } from '../posting/Socialarray'
import feed from "../assets/feed.png"
import dot from "../assets/dot.png"

function Tab1() {
    return (<>




        {
            HeaderData.map((e) => {
                return (<>
                    <div className='schedule_card'>
                        <p className='schedule_date'>{e.date}</p><br></br>
                        <div className='schdule_card'>
                            <div className='main_sch'>
                                <div className='sch_user'>
                                    <img style={{height:"30px",width:"30px"}} src={user} />
                                    <p>{e.name}</p>
                                </div>
                                <div className='time_tab_div'>
                                    <div>03:30 AM</div>
                                    <img style={{width:"100%",maxWidth:"20px"}}  src={time} />
                                </div>
                            </div>
                            {/* <p className='sch_text'>{e.text}</p> */}
                          
                            <img className='sch_pic' src={feed} />
                            <div className='d-flex gap -3 justify-content-between flex-wrap align-items-center mt-3 '>
                                <img style={{width:"100%",maxWidth:"30px"}} src={upload} />
                                <div className='d-flex gap-1'>
                                    <img className='dot' src={dot} />
                                    <img className='dot' src={dot} />
                                    <img className='dot' src={dot} />
                                </div>
                            </div>
                        </div>
                    </div>

                </>)
            })
        }








    </>

    )
}

export default Tab1